var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{staticClass:"d-flex justify-end mb-4 px-4"},[_c('EventTabReportExportExcel')],1),_c('EventTabReportTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }